import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { clubForId } from 'utils/clubFeatures';
import {
  GROUPING_BASIS,
  groupingBasisOf,
  groupPhrases,
  groupWords,
  oldestGroupPlacedByAge,
} from 'utils/groupLabel';

// How the club on screen groups its athletes, and the words it reads for it
// (utils/groupLabel.js): Age and Age Group, or Year and Year Group for a club
// that groups by year level.
//
// It also gives the highest group number the club places by age
// (oldestGroupPlacedByAge): an athlete above it is an adult, placed in their
// own race.
//
// The club is the one named in the web address when there is one (the meet
// and results pages carry a club id), or the one passed in, and otherwise the
// selected club. It is read from the club list already in memory, so no
// request is made.
const useGroupLabels = (clubId) => {
  const { clubId: routeClubId } = useParams();
  const groupingBasis = useSelector((state) =>
    groupingBasisOf(clubForId(state.user, clubId || routeClubId))
  );
  const oldestPlacedByAge = useSelector((state) =>
    oldestGroupPlacedByAge(clubForId(state.user, clubId || routeClubId))
  );
  return {
    groupingBasis,
    oldestPlacedByAge,
    byYearLevel: groupingBasis === GROUPING_BASIS.YEAR_LEVEL,
    words: groupWords(groupingBasis),
    phrases: groupPhrases(groupingBasis),
  };
};

export default useGroupLabels;
